<div class="eui-table__filter">
    <form [formGroup]="form">
        <div class="eui-clearable-input-wrapper">
            <input #filterInput class="eui-table__filter-input" type="text" formControlName="filter" [attr.aria-label]="placeholder? placeholder: 'Filter Input Field'" placeholder="{{ placeholder }}">
            <span euiIcon aria-label="Search Icon" class="eui-table__filter-search-icon eui-icon eui-icon-search-m"></span>
            <span euiIcon aria-label="Clear Icon" class="eui-clearable-input-wrapper__clear" *ngIf="form.get('filter').value" (click)="resetFilter()"></span>
        </div>
    </form>
</div>
